export default {
    new: "new",
    flagged: "flagged",
    enhanced: "enhanced",
    approved: "approved",
    rejected: "rejected",
};
